import React, { Dispatch, SetStateAction, useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { useNavigate } from "react-router-dom";
import { GoChevronDown } from "react-icons/go";
import { useTranslation } from "react-i18next";
import LanguageSwitch from "../Languages/LanguageSwitch";
import { MenuContent } from "./MenuContent";
import { useOpenCloseMenu } from "../../hooks/useOpenCloseMenu";
import ButtonFullWidth from "../Buttons/ButtonFullWidth";

function DropdownMenu(
  props: Readonly<{
    buttonName?: string;
    setIsAllMenuOpen: Dispatch<SetStateAction<boolean>>;
    isAllMenuOpen: boolean;
    isChildMenu: boolean;
    isInline?: boolean;
    menuContent?: MenuContent[];
  }>
) {
  const navigate = useNavigate();
  const [isMouseOut, setIsMouseOut] = useState(false);
  const [isCurrentMenuOpen, setIsCurrentMenuOpen] = useState(false);
  const { t } = useTranslation();

  useOpenCloseMenu({ isMouseOut, setIsCurrentMenuOpen });

  return (
    <div
      className="text-sm md:text-md w-full"
      onMouseEnter={() => {
        setIsMouseOut(false);
        props.setIsAllMenuOpen(true);
        setIsCurrentMenuOpen(true);
      }}
      onMouseLeave={() => {
        setIsMouseOut(true);
      }}
      role="none"
    >
      <button
        onClick={() => {
          setIsMouseOut(false);
          if (!props.isChildMenu) {
            props.setIsAllMenuOpen(!props.isAllMenuOpen);
            setIsCurrentMenuOpen(!props.isAllMenuOpen);
          } else {
            setIsCurrentMenuOpen(!isCurrentMenuOpen);
          }
        }}
        className="w-full"
      >
        {props.buttonName === "hamburger" && (
          <GiHamburgerMenu className="text-2xl" />
        )}
        {props.buttonName !== "hamburger" && (
          <div
            className={
              props.isInline
                ? "flex items-center pl-[7px] pr-[7px] md:pt-[8px] md:pb-[8px] rounded-md hover:bg-lightbg-150 "
                : "w-full flex items-center  pl-[20px] pt-[4px] pb-[4px] md:pt-[8px] md:pb-[8px] rounded-md hover:bg-lightbg-150 "
            }
          >
            {t([`Menu.${props.buttonName}`])}
            <GoChevronDown />
          </div>
        )}
      </button>
      <div className="relative ">
        {props.isAllMenuOpen && isCurrentMenuOpen && (
          <div
            className={
              "flex flex-col items-start rounded-md pt-[5px] pb-[5px] w-[100px] md:w-[208px] pl-[5px] pr-[5px]  absolute right-[90%] shadow-2xl border-lightbg-100 border-solid border-[1px] bg-lightbg-200 "
            }
          >
            {props.menuContent?.map((menuContent) => {
              switch (menuContent.Type) {
                case "Route": {
                  if (menuContent.Route?.IsMainRoute) {
                    return (
                      <ButtonFullWidth
                        key={"dropdown" + menuContent.Route?.Name}
                        onClick={() => {
                          props.setIsAllMenuOpen(false);
                          setIsCurrentMenuOpen(false);
                          navigate(menuContent.Route?.Route ?? "");
                        }}
                      >
                        {t("Menu." + menuContent.Route?.Name)}
                      </ButtonFullWidth>
                    );
                  } else {
                    return (
                      <DropdownMenu
                        key={"dropdown" + menuContent.Route?.Name}
                        buttonName={menuContent.Name}
                        setIsAllMenuOpen={props.setIsAllMenuOpen}
                        isAllMenuOpen={props.isAllMenuOpen}
                        isChildMenu={true}
                        isInline={false}
                        menuContent={menuContent.SubMenu}
                      />
                    );
                  }
                }
                case "Language": {
                  return (
                    <LanguageSwitch
                      key="languagedropdown"
                      setIsAllMenuOpen={props.setIsAllMenuOpen}
                      isAllMenuOpen={props.isAllMenuOpen}
                      languages={menuContent.Languages}
                      isInline={false}
                    />
                  );
                }
                case "Link": {
                  return <div></div>;
                }
                default: {
                  return <div></div>;
                }
              }
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default DropdownMenu;
